// Renders RELEASES newest-first: version + label + date badge, one-line hook,
// New → Improved → Fixed buckets (empty ones omitted), actionRequired as a warn Callout.
import { Callout } from '../pages/shell';
import { RELEASES, type ReleaseNote } from './registry';

function Bucket({ title, items }: { title: string; items?: string[] }) {
  if (!items || items.length === 0) return null;
  return (
    <div style={{ marginTop: 12 }}>
      <span className="cr-label" style={{ color: 'var(--fg-2)' }}>{title}</span>
      <ul style={{ margin: '8px 0 0', padding: '0 0 0 18px', display: 'flex', flexDirection: 'column', gap: 6 }}>
        {items.map((it, i) => (
          <li key={i} style={{ fontSize: 14, lineHeight: 1.6, color: 'var(--fg-2)' }}>{it}</li>
        ))}
      </ul>
    </div>
  );
}

function ReleaseEntry({ note }: { note: ReleaseNote }) {
  return (
    <section style={{ borderTop: '1px solid var(--line-1)', padding: '24px 0 4px' }}>
      <div style={{ display: 'flex', alignItems: 'baseline', gap: 12, flexWrap: 'wrap' }}>
        <h2 style={{ margin: 0, fontFamily: 'var(--font-display)', fontSize: 22, fontWeight: 700, letterSpacing: 'var(--tracking-heading)', color: 'var(--fg-1)' }}>
          ClipRadar {note.label ?? note.version}
        </h2>
        <span style={{ fontFamily: 'var(--font-mono)', fontSize: 10.5, letterSpacing: '0.06em', textTransform: 'uppercase', color: 'var(--fg-3)', padding: '3px 8px', borderRadius: 6, border: '1px solid var(--line-2)', background: 'var(--surface-card)' }}>
          {note.date}
        </span>
      </div>
      <p style={{ margin: '10px 0 0', fontSize: 14.5, lineHeight: 1.65, color: 'var(--fg-2)' }}>{note.hook}</p>
      {note.actionRequired ? <Callout kind="warn">{note.actionRequired}</Callout> : null}
      <Bucket title="New" items={note.New} />
      <Bucket title="Improved" items={note.Improved} />
      <Bucket title="Fixed" items={note.Fixed} />
    </section>
  );
}

export function ReleaseNotes() {
  const shipped = RELEASES.filter((r) => r.shipped);

  if (!shipped.length) {
    return <p style={{ fontSize: 14.5, color: 'var(--fg-3)' }}>Release notes are being prepared.</p>;
  }
  return (
    <div style={{ display: 'flex', flexDirection: 'column' }}>
      {shipped.map((r) => <ReleaseEntry key={r.version} note={r} />)}
    </div>
  );
}
